export let hrms31eColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_typproba',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'dteoccup',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dteduepr',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_staupd',
    name: '',
    labelCodapp: 'HRPM31EC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }]

  let tab3Table1Columns = [{
    key: 'typleave',
    name: '',
    labelCodapp: 'HRPM31EP3',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_typleave',
    name: '',
    labelCodapp: 'HRPM31EP3',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'numleave',
    name: '',
    labelCodapp: 'HRPM31EP3',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;'
  }]

  let tab3Table2Columns = [{
    key: 'dteeffec',
    name: '',
    labelCodapp: 'HRPM31EP3',
    labelIndex: '180',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desmist1',
    name: '',
    labelCodapp: 'HRPM31EP3',
    labelIndex: '190',
    style: 'min-width: 300px;'
  }]

  return {
    en: {
      index: indexColumns,
      columnsTab3Table1: tab3Table1Columns,
      columnsTab3Table2: tab3Table2Columns
    },
    th: {
      index: indexColumns,
      columnsTab3Table1: tab3Table1Columns,
      columnsTab3Table2: tab3Table2Columns
    }
  }
}




// WEBPACK FOOTER //
// ./src/assets/columns/hrms31e.js